;(function() {
  'use strict'

  angular.module('core.surveyListSelect', [])
})()
